import type { Theme } from "@mui/material/styles";

export const getDialogPaperSx = (theme: Theme) => ({
  borderRadius: 1,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  backgroundImage: "none",
  boxShadow: "none",
  overflow: "hidden",
});

export const dialogShellSx = {
  display: "flex",
  flexDirection: "column",
  maxHeight: "min(88vh, 940px)",
  backgroundColor: "background.paper",
} as const;

export const getDialogHeaderSx = (theme: Theme) => ({
  position: "relative",
  px: 2,
  py: 2,
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
});

export const dialogTitleSx = {
  fontSize: "1rem",
  fontWeight: 600,
  lineHeight: 1.5,
} as const;

export const dialogBodySx = {
  px: 2,
  py: 2,
  overflowY: "auto",
} as const;

export const getDialogFooterSx = (theme: Theme) => ({
  position: "sticky",
  bottom: 0,
  display: "flex",
  alignItems: "center",
  boxSizing: "border-box",
  px: 2,
  py: 1,
  minHeight: 52,
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
});

export const dialogActionsSx = {
  flex: 1,
  minHeight: 0,
  alignItems: "center",
  justifyContent: "flex-end",
  gap: 1,
  px: 0,
  py: 0,
} as const;

export const getDialogCloseButtonSx = (theme: Theme) => ({
  position: "absolute",
  right: 8,
  top: 8,
  color: theme.palette.grey[500],
});
